import { defineNuxtPlugin } from '#imports';
import configPaths from '@@/configuration/paths.json';

const paths = {
    landingPage: {
        'sv-SE': '/',
        'en-EU': '/en-EU',
    },
    terms: {
        'sv-SE': '/',
    },
    ...configPaths,
};

const endpoints = {
    layout: 'cms-view/v1/content/layout',
    page: 'cms-view/v1/content/page',
};

export { paths };
export { endpoints };

export default defineNuxtPlugin(nuxtApp => {
    const { $i18n } = nuxtApp;

    return {
        provide: {
            paths: {
                getPath(key) {
                    try {
                        if (paths[key][$i18n.locale.value]) {
                            return paths[key][$i18n.locale.value];
                        }
                    } catch (e) {
                        if (process.env.NODE_ENV === 'development') {
                            console.warn(`No path found in paths plugin for ${key}`);
                        }

                        return '/';
                    }
                },
                getEndpoint(alias) {
                    if (endpoints[alias]) {
                        return endpoints[alias];
                    }

                    return '';
                },
            },
        },
    };
});
